import tw from "twin.macro"
import styled from "@emotion/styled/macro"

import { H5 } from "../../Styled/Text"

export const Section = tw.section`relative z-1 bg-white overflow-hidden`
export const Banner = tw.div`relative bg-teal pb-48`
export const Images = styled.div`
  &,
  > * {
    ${tw`inset-0`}
    position: absolute !important;
  }
  ${tw`transition-opacity duration-500`}
  ${({ active }) => (active ? tw`opacity-100` : tw`opacity-0`)}
`
export const Content = tw.div`relative w-full flex flex-col items-end justify-start text-left text-white py-24 md:pt-28.25 md:pb-63.5`
export const Title = tw(H5)`md:mr-6 md:w-95 md:max-w-full`
